export const SUPER_ADMIN = { name: 'SUPER_ADMIN', label: 'Super Admin', type: 'SECURITY' }
export const ADMIN = { name: 'ADMIN', label: 'Admin', type: 'SECURITY' }
export const CONSULTANT = { name: 'CONSULTANT', label: 'Consultant', type: 'SECURITY' }
export const RECRUITER = { name: 'RECRUITER', label: 'Recruiter', type: 'BUSINESS' }
export const SALES_PERSON = { name: 'SALES_PERSON', label: 'Sales Person', type: 'BUSINESS' }
export const MANAGER = { name: 'MANAGER', label: 'Manager', type: 'MANAGER' }

export const securityRolesList = [SUPER_ADMIN, ADMIN, CONSULTANT]
export const businessRolesList = [RECRUITER, SALES_PERSON]
export const managerRolesList = [MANAGER]
export const allRolesList = securityRolesList.concat(businessRolesList).concat(managerRolesList)

export default [ SUPER_ADMIN, ADMIN, CONSULTANT, RECRUITER, SALES_PERSON, MANAGER ]
